import { render, staticRenderFns } from "./ElectiveCosmetRegister.vue?vue&type=template&id=b74200f8&"
import script from "./ElectiveCosmetRegister.vue?vue&type=script&lang=js&"
export * from "./ElectiveCosmetRegister.vue?vue&type=script&lang=js&"
import style0 from "./ElectiveCosmetRegister.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ElectiveCosmetRegister.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports